import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { DataGrid } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Snackbar from '@mui/material/Snackbar';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from "@mui/material/Autocomplete";
import Stack from '@mui/material/Stack';
import { fetchRecipientAddress, destoryRecipientAddress, storeRecipientAddress, updateRecipientAddress, importRecipientAddress, resetRecipientAddressState, resetImportRecipientAddressState } from './addressRecipientSlice';
import { fetchCountry, fetchState } from '../../../pages/General/countryStateCitySlice';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import UploadIcon from '@mui/icons-material/Upload';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from "@mui/icons-material/Clear";

import NorowsData from '../../../pages/General/NorowsData';

const Input = styled('input')({
    display: 'none',
});

// Reusable standard layout styling dictionary configuring premium outlined enterprise input tracks
const enterpriseAddressInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': {
            borderColor: '#CBD5E1',
            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
        },
        '&.Mui-focused': {
            borderColor: '#1976d2', // --- CORPORATE IDENTITY ACCENT BRAND BLUE ---
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiInputLabel-outlined': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 10px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1976d2',
            fontWeight: 600
        }
    },
    '& input, & .MuiSelect-select': {
        padding: '10px 14px !important',
        fontSize: '13.5px',
        color: '#1E293B',
        fontWeight: 500
    },
    '& .MuiFormHelperText-root': {
        mx: 0.5,
        mt: 0.75,
        fontWeight: 500
    }
};

const enterpriseModalContainerStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '94%', sm: 700, md: 800 },
    maxHeight: '90vh',
    overflowY: 'auto',
    outline: 'none',
    border: 'none',
    boxSizing: 'border-box'
};

const enterpriseImportModalContainerStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '94%', sm: 540 },
    outline: 'none',
    border: 'none',
    boxSizing: 'border-box'
};

const enterpriseAddressDeleteModalStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 420 },
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    border: '1px solid #E2E8F0',
    p: 4,
    outline: 'none',
    overflow: 'hidden'
};

const Modalpopup = ({ modalVisible, setModalVisible, formValues, setFormValues }) => {
    const dispatch = useDispatch();
    const addressrecipient = useSelector(state => state.addressrecipient && state.addressrecipient.addressrecipient);
    const profile = useSelector(state => state.auth.profile);
    const country = useSelector(state => state.countrystate.country);
    const state = useSelector(state => state.countrystate.state);
    const initialRecipientAddressValues = {
        name: '',
        company: '',
        address: '',
        address2: '',
        city: '',
        province_code: '',
        country_code: '',
        postal_code: '',
        email: '',
        phone: '',
        customer_id: '',
        reference: '',
        reference2: '',
        reference3: '',
    }
    const [values, setValues] = useState(formValues && Object.keys(formValues).length === 0 ? initialRecipientAddressValues : formValues);
    const [errors, setErrors] = useState({});
    const filteredCountryData = country.data.filter(({ code }) => code );

    useEffect(() => {
        if (formValues && formValues.country_code) {
            dispatch(fetchState(formValues && formValues.country_code));
        }
    }, [formValues]);

    useEffect(() => {
        if (formValues && Object.keys(formValues).length !== 0) {
            let tempValues = {
                name: formValues['name'],
                company: formValues['company'],
                address: formValues['address'],
                address2: formValues['address2'],
                city: formValues['city'],
                province_code: formValues['province_code'],
                country_code: formValues['country_code'],
                postal_code: formValues['postal_code'],
                email: formValues['email'],
                phone: formValues['phone'],
                customer_id: formValues['customer_id'],
                reference: formValues['reference'],
                reference2: formValues['reference2'],
                reference3: formValues['reference3'],
            };
            setValues(tempValues)
        }
    }, [formValues])

    useEffect(() => {
        if (addressrecipient && addressrecipient.message && addressrecipient.message != "") {
            if (addressrecipient && addressrecipient.messageType == 'success') {
                setValues(initialRecipientAddressValues)
                setErrors({})
            }
        }
    }, [addressrecipient.message]);

    const onModalClose = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        onModalEditClose()
    }

    const onModalEditClose = () => {
        setFormValues(initialRecipientAddressValues)
        setModalVisible(false)
        dispatch(resetRecipientAddressState())
        dispatch(resetImportRecipientAddressState())
    }

    const onInputChange = e => {
        const { name, value } = e.target
        if(e.target.name === 'postal_code'){
            setValues({
                ...values,
                [name]: value.replace(/\s/g, ''),
            });
       }else{
            setValues({
                ...values,
                [name]: value
            })
        }
        validator({ [name]: value })
    }

    const onSelectCountryChange = (countryCode) => {
        setValues({
        ...values,
        country_code: countryCode,
        });
        setErrors({ country_code: "" });
        dispatch(fetchState(countryCode));
    };

    const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
        if (key.code == country_code) {
            filteredValue = key;
        }
        });
        return filteredValue;
    };

    const onSelectStateChange = (currentstate) => {
        setValues({
        ...values,
        province_code: currentstate,
        });
        setErrors({ province_code: "" });
    };

    const getSelectedState = (currentstate) => {
        let filteredStateValue = { code: "", name: "" };
        let tempState = "";
        state &&
        state.data &&
        state.data.map((key) => {
            if (key.code == currentstate && tempState == "") {
            filteredStateValue = key;
            tempState = "success";
            }
        });
        return filteredStateValue;
    };

    const handleSubmit = e => {
        e.preventDefault()
        const isValid = validator(values)
        if (isValid) {
            if ("_id" in formValues) {
                dispatch(updateRecipientAddress(profile && profile.id,formValues._id, values))
            } else {
                dispatch(storeRecipientAddress(profile && profile.id,values))
            }
        }
    }

    const validator = (fieldValues) => {
        let temp = { ...errors }
        if ('name' in fieldValues)
            temp.name = fieldValues.name ? "" : "This field is required."
        if (fieldValues && fieldValues.name && fieldValues.name.length < 3)
            temp.name = "Recipient Name required minimum 3 characters"
        if ('address' in fieldValues)
            temp.address = fieldValues.address ? "" : "This field is required."
        if ('city' in fieldValues)
            temp.city = fieldValues.city ? "" : "This field is required."
        if ('email' in fieldValues)
            temp.email = fieldValues.email ? "" : "This field is required."
        if ('postal_code' in fieldValues)
            temp.postal_code = fieldValues.postal_code ? "" : "This field is required."
        if ((fieldValues && fieldValues.postal_code && fieldValues.postal_code.length < 3) ||
            (fieldValues && fieldValues.postal_code && fieldValues.postal_code === null))
            temp.postal_code = "Recipient postal code required minimum 3 characters"
        if (fieldValues && fieldValues.postal_code && fieldValues.postal_code.match(/[^0-9a-z\s]/i))
            temp.postal_code = "Postal code only accepts alpha numeric"
        if ('province_code' in fieldValues)
            temp.province_code = fieldValues.province_code ? "" : "This field is required."
        if ('country_code' in fieldValues)
            temp.country_code = fieldValues.country_code ? "" : "This field is required."
        setErrors({
            ...temp
        })

        if (fieldValues === values) {
            return Object.values(temp).every(x => x == "")
        }
    }

    return (
        <Modal
            open={modalVisible}
            onClose={onModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            closeAfterTransition
        >
            <Box sx={enterpriseModalContainerStyles}>
                <Card 
                    className="sc--cardhead--details"
                    sx={{ 
                        backgroundColor: '#FFFFFF',
                        borderRadius: '16px',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        border: '1px solid #E2E8F0',
                        overflow: 'hidden'
                    }}
                >
                    <CardHeader 
                        title={
                            <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                Recipient Address
                            </Typography>
                        }  
                        action={
                            <IconButton 
                                aria-label="close" 
                                onClick={onModalClose}
                                sx={{ color: '#64748B', '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' } }}
                            >
                                <CloseIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        }
                        sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                    />
                    <Divider sx={{ borderColor: '#E2E8F0' }} />
                    <CardContent sx={{ p: 4, boxSizing: 'border-box' }}>
                        <Grid container spacing={3}>
                            
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Name*"
                                    name="name"
                                    size="small"
                                    defaultValue={formValues && formValues.name}
                                    onChange={onInputChange}
                                    error={!!errors.name}
                                    helperText={errors.name}
                                    inputProps={{ maxLength: 40 }}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Company"
                                    name="company"
                                    size="small"
                                    defaultValue={formValues && formValues.company}
                                    onChange={onInputChange}
                                    inputProps={{ maxLength: 40 }}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Phone"
                                    name="phone"
                                    size="small"
                                    defaultValue={formValues && formValues.phone}
                                    onChange={onInputChange}
                                    inputProps={{ maxLength: 13 }}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Email*"
                                    name="email"
                                    size="small"
                                    defaultValue={formValues && formValues.email}
                                    onChange={onInputChange}
                                    error={!!errors.email}
                                    inputProps={{ maxLength: 60 }}
                                    helperText={errors.email}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Address1*"
                                    name="address"
                                    size="small"
                                    defaultValue={formValues && formValues.address}
                                    onChange={onInputChange}
                                    error={!!errors.address}
                                    inputProps={{ maxLength: 35 }}
                                    helperText={errors.address}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Address2"
                                    name="address2"
                                    size="small"
                                    defaultValue={formValues && formValues.address2}
                                    onChange={onInputChange}
                                    inputProps={{ maxLength: 35 }}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Postal Code*"
                                    name="postal_code"
                                    size="small"
                                    defaultValue={formValues && formValues.postal_code}
                                    onChange={onInputChange}
                                    inputProps={{ maxLength: 10 }}
                                    error={!!errors.postal_code}
                                    helperText={errors.postal_code}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="City*"
                                    name="city"
                                    size="small"
                                    defaultValue={formValues && formValues.city}
                                    onChange={onInputChange}
                                    error={!!errors.city}
                                    inputProps={{ maxLength: 30 }}
                                    helperText={errors.city}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    className="help-text-error"
                                    disablePortal
                                    size="small"
                                    name="country_code"
                                    id="country-select-demo"
                                    options={filteredCountryData}
                                    autoHighlight
                                    loading={country && country.loading}
                                    getOptionLabel={(option) => option.name || ""}
                                    value={getSelectedCountry(values && values.country_code)}
                                    sx={{
                                        width: '100%',
                                        '& .MuiAutocomplete-inputRoot': enterpriseAddressInputStyles['& .MuiOutlinedInput-root'],
                                        '& .MuiInputLabel-root': enterpriseAddressInputStyles['& .MuiInputLabel-outlined'],
                                        '& input': enterpriseAddressInputStyles['& input']
                                    }}
                                    renderOption={(props, option) => (
                                    <MenuItem {...props} value={option.code} key={option.code} sx={{ fontSize: '13.5px', fontWeight: 500 }}>
                                        {option.icon} {option.name}
                                    </MenuItem>
                                    )}
                                    onChange={(event, value) => {
                                        if (value !== null) {
                                          onSelectCountryChange(value.code);
                                          setErrors({ country_code: "" });
                                        } else {
                                          onSelectCountryChange("");
                                          setErrors({ country_code: "This field is required" });
                                        }
                                      }}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Country*"
                                        variant="outlined"
                                        error={!!errors.country_code}
                                        helperText={errors.country_code}
                                        sx={{ '& .MuiFormHelperText-root': enterpriseAddressInputStyles['& .MuiFormHelperText-root'] }}
                                    />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    className="help-text-error"
                                    disablePortal
                                    size="small"
                                    name="province_code"
                                    id="state-select-demo"
                                    options={state && state.data || []}
                                    autoHighlight
                                    loading={(state && state.loading) || (country && country.loading)}
                                    getOptionLabel={(option) => option.name || ""}
                                    value={getSelectedState(values && values.province_code)}
                                    sx={{
                                        width: '100%',
                                        '& .MuiAutocomplete-inputRoot': enterpriseAddressInputStyles['& .MuiOutlinedInput-root'],
                                        '& .MuiInputLabel-root': enterpriseAddressInputStyles['& .MuiInputLabel-outlined'],
                                        '& input': enterpriseAddressInputStyles['& input']
                                    }}
                                    renderOption={(props, option) => (
                                    <MenuItem {...props} value={option.code} key={option.code} sx={{ fontSize: '13.5px', fontWeight: 500 }}>
                                        {option.name}
                                    </MenuItem>
                                    )}
                                    onChange={(event, value) => {
                                        if (value !== null) {
                                          onSelectStateChange(value.code);
                                        } else {
                                          onSelectStateChange("");
                                        }
                                      }}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="State*"
                                        variant="outlined"
                                        error={!!errors.province_code}
                                        helperText={errors.province_code}
                                        sx={{ '& .MuiFormHelperText-root': enterpriseAddressInputStyles['& .MuiFormHelperText-root'] }}
                                    />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Customer ID"
                                    name="customer_id"
                                    size="small"
                                    defaultValue={formValues && formValues.customer_id}
                                    onChange={onInputChange}
                                    inputProps={{ maxLength: 30 }}
                                    error={!!errors.customer_id}
                                    helperText={errors.customer_id}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Reference"
                                    name="reference"
                                    size="small"
                                    defaultValue={formValues && formValues.reference}
                                    onChange={onInputChange}
                                    inputProps={{ maxLength: 30 }}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Reference 2"
                                    name="reference2"
                                    size="small"
                                    defaultValue={formValues && formValues.reference2}
                                    onChange={onInputChange}
                                    inputProps={{ maxLength: 30 }}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Reference 3"
                                    name="reference3"
                                    size="small"
                                    defaultValue={formValues && formValues.reference3}
                                    onChange={onInputChange}
                                    inputProps={{ maxLength: 30 }}
                                    variant="outlined"
                                    sx={enterpriseAddressInputStyles}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, pt: 2, borderTop: '1px solid #E2E8F0', mt: 1 }}>
                                    <Button 
                                        variant="outlined" 
                                        onClick={onModalClose}
                                        sx={{
                                            textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 3,
                                            borderColor: '#E2E8F0', color: '#475569', '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        onClick={handleSubmit}
                                        sx={{
                                            textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 4, boxShadow: 'none',
                                            backgroundColor: '#1976d2', color: '#FFFFFF', '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </Grid>

                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Modal >
    )
}

const ModalImportPopup = ({ modalImportVisible, setModalImportVisible, setSnackOpen, setAlertImport }) => {
    const dispatch = useDispatch();
    const importaddressrecipient = useSelector(state => state.addressrecipient && state.addressrecipient.importaddressrecipient);
    const profile = useSelector(state => state.auth.profile);
    const [fileUpload, setFileUpload] = useState("")
    const [fileName, setFileName] = useState("")
    const [buttonSubmitDisabled, setButtonSubmitDisabled] = useState(true)
    const [buttonUploadDisabled, setButtonUploadDisabled] = useState(false)

    useEffect(() => {
        if (importaddressrecipient && importaddressrecipient.message && importaddressrecipient.message !== "") {
            setFileName("")
            setFileUpload("")
            setButtonSubmitDisabled(true)
            setButtonUploadDisabled(false)
            setSnackOpen(true)
            setAlertImport(true)
            if (importaddressrecipient && importaddressrecipient.messageType && importaddressrecipient.messageType === 'success') {
                setModalImportVisible(false)
            }
        }
    }, [importaddressrecipient.message])

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        onModalImportClose();
    }

    const onModalImportClose = () => {
        setFileName("")
        setFileUpload("")
        setButtonSubmitDisabled(true)
        setButtonUploadDisabled(false)
        setModalImportVisible(false)
        dispatch(resetRecipientAddressState())
        dispatch(resetImportRecipientAddressState())
    }

    const onFileUpload = (e) => {
        e.preventDefault()
        if (e.target.files && e.target.files.length === 0) {
            setFileName(fileUpload.name)
            setFileUpload(fileUpload);
        } else {
            setFileUpload(e.target.files[0]);
            setFileName(e.target.files[0].name)
        }
        setButtonSubmitDisabled(false)
    }

    const onSubmit = () => {
        var formData = new FormData();
        formData.append('file', fileUpload);
        dispatch(importRecipientAddress(profile && profile.id,formData))
        setFileName("")
        setFileUpload("")
        setButtonSubmitDisabled(true)
        setButtonUploadDisabled(true)
    }

    return (
        <Modal
            open={modalImportVisible}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            closeAfterTransition
        >
            <Box sx={enterpriseImportModalContainerStyles}>
                <Card 
                    className="sc--cardhead--details"
                    sx={{ 
                        backgroundColor: '#FFFFFF',
                        borderRadius: '16px',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        border: '1px solid #E2E8F0',
                        overflow: 'hidden'
                    }}
                >
                    <CardHeader 
                        title={
                            <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                Import Recipient Address
                            </Typography>
                        } 
                        action={
                            <IconButton 
                                aria-label="close" 
                                onClick={onModalImportClose}
                                sx={{ color: '#64748B', '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' } }}
                            >
                                <CloseIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        }
                        sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                    />
                    {importaddressrecipient && importaddressrecipient.loading === true && (
                        <LinearProgress sx={{ height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                    )}
                    <Divider sx={{ borderColor: '#E2E8F0' }} />
                    <CardContent sx={{ p: 4 }}>
                        <Stack spacing={3} alignItems="center" justifyContent="center" sx={{ py: 2 }}>
                            <Box sx={{ width: '100%', p: 3, border: '2px dashed #E2E8F0', borderRadius: '12px', backgroundColor: '#F8FAFC', textAlign: 'center' }}>
                                <label htmlFor="contained-button-file">
                                    <Input accept=".csv" id="contained-button-file" onChange={onFileUpload} key={fileName} name='import_recipient_address_book' type="file" />
                                    <Button 
                                        variant="contained" 
                                        component="span" 
                                        disabled={buttonUploadDisabled}
                                        startIcon={<UploadIcon />}
                                        sx={{
                                            textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13px', boxShadow: 'none',
                                            backgroundColor: '#1E293B', color: '#FFFFFF', '&:hover': { backgroundColor: '#0F172A', boxShadow: 'none' }
                                        }}
                                    >
                                        Choose CSV File
                                    </Button>
                                </label>
                                {fileName && (
                                    <Typography variant="body2" sx={{ color: '#0F172A', fontWeight: 600, mt: 2, fontSize: '13px' }}>
                                        Selected: {fileName}
                                    </Typography>
                                )}
                            </Box>
                            
                            <Button 
                                variant="text" 
                                component="a" 
                                href="https://shippingchimp.s3.us-east-2.amazonaws.com/labelgen/sample/Sample+Recipient+Address+Book.csv"
                                sx={{ fontSize: '13px', fontWeight: 600, color: '#1976d2', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                            >
                                Download Sample Recipient Address CSV Template
                            </Button>
                            
                            <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, pt: 2, borderTop: '1px solid #E2E8F0', mt: 1 }}>
                                <Button 
                                    variant="outlined" 
                                    onClick={onModalImportClose}
                                    sx={{
                                        textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 3,
                                        borderColor: '#E2E8F0', color: '#475569', '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    variant="contained" 
                                    onClick={onSubmit} 
                                    disabled={buttonSubmitDisabled}
                                    sx={{
                                        textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 4, boxShadow: 'none',
                                        backgroundColor: '#1976d2', color: '#FFFFFF', '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                        '&.Mui-disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' }
                                    }}
                                >
                                    Import Directory
                                </Button>
                            </Box>
                        </Stack>
                    </CardContent>
                </Card>
            </Box>
        </Modal >
    )
}

const AddressRecipientPage = () => {
    const dispatch = useDispatch();
    const addressrecipient = useSelector(state => state.addressrecipient && state.addressrecipient.addressrecipient);
    const importaddressrecipient = useSelector(state => state.addressrecipient && state.addressrecipient.importaddressrecipient);
    const profile = useSelector(state => state.auth.profile);
    const [addressAlert, setAddressAlert] = useState(false);
    const [alertImport, setAlertImport] = useState(false);
    const [snackOpen, setSnackOpen] = React.useState(false);
    const [deleteModalopen, setDeleteModalopen] = React.useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalImportVisible, setModalImportVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [deleteid, setDeleteId] = React.useState("");
    const [pageSize, setPageSize] = useState(10);
    const [showSearch, setShowSearch] = useState(false);
    const [addressSearchValues, setAddressSearchValues] = useState({
        "search_by": "name",
        "search_value": ""
    })

    useEffect(() => {
        dispatch(fetchRecipientAddress(addressSearchValues));
        dispatch(fetchCountry());
    }, [dispatch]);

    useEffect(() => {
        if (addressrecipient && addressrecipient.message && addressrecipient.message !== "") {
            setAddressAlert(true)
            setSnackOpen(true)
            if (addressrecipient && addressrecipient.messageType == 'success') {
                setModalVisible(false)
                setSelectedItem({})
            }
        }
    }, [addressrecipient.message]);

    const handleOnClickDelete = (id) => {
        setDeleteId(id)
        setDeleteModalopen(true);
    };

    const deleteModalClose = () => {
        setDeleteModalopen(false);
    };

    const deleteaddress = (id) => {
        dispatch(destoryRecipientAddress(profile && profile.id,id))
        setAddressAlert(true)
        setSnackOpen(true)
        setDeleteModalopen(false);
    }
    const snackhandleClose = () => {
        setAddressAlert(false)
        setAlertImport(false)
        setSnackOpen(false)
        dispatch(resetRecipientAddressState())
        dispatch(resetImportRecipientAddressState())
    };

    const snackbar = (value) => {
        setSnackOpen(value)
    }

    const onInputClear = () => {
        let tempAddressSearchValues = { ...addressSearchValues };
        tempAddressSearchValues["search_value"] = ""
        setAddressSearchValues(tempAddressSearchValues);
        dispatch(fetchRecipientAddress(tempAddressSearchValues));
    };

    const onMenuClick = () => {
        setShowSearch(!showSearch)
        if (showSearch) {
            setAddressSearchValues({
                "search_by": "name",
                "search_value": ""
            });
            dispatch(fetchRecipientAddress({
                "search_by": "name",
                "search_value": ""
            }));
        }
    }

    const onSearchAddressFieldsChange = (event) => {
        let addressSearchValuesTemp = { ...addressSearchValues };
        addressSearchValuesTemp[event.target.name] = event.target.value
        setAddressSearchValues(addressSearchValuesTemp)
        if(event.target.value === ""){
            dispatch(fetchRecipientAddress(addressSearchValuesTemp));
        }
    }

    const onSearchAddressFieldsEnter = (event) => {
        let addressSearchValuesTemp = { ...addressSearchValues };
        if (event.charCode === 13 && addressSearchValuesTemp.search_value != "") {
            dispatch(fetchRecipientAddress(addressSearchValuesTemp));
        }
    }

    const columns = [
        { field: 'name', headerName: 'Name', flex:1, minWidth: 130 },
        { field: 'company', headerName: 'Company Name', flex:1, minWidth: 140 },
        { field: 'phone', headerName: 'Phone Number', flex:1, minWidth: 130 },
        { field: 'email', headerName: 'Email', flex:1, minWidth: 150 },
        { field: 'address', headerName: 'Address', flex:1.2, minWidth: 160 },
        { field: 'city', headerName: 'City', flex:1, minWidth: 110 },
        { field: 'province_code', headerName: 'Province Code', flex:0.8, minWidth: 110 },
        { field: 'country_code', headerName: 'Country Code', flex:0.8, minWidth: 110 },
        { field: 'postal_code', headerName: 'Postal Code', flex:0.8, minWidth: 110 },
        { field: 'reference', headerName: 'Reference', flex:1, minWidth: 120 },
        {
            field: 'action',
            headerName: 'Action',
            flex:1,
            minWidth: 110,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
                        <Tooltip title="Edit Entry" placement="top">
                            <IconButton
                                onClick={() => {
                                    setSelectedItem(params.row);
                                    setModalVisible(true)
                                }}
                                sx={{ 
                                    color: '#64748B', padding: '6px', borderRadius: '8px', border: '1px solid #E2E8F0', backgroundColor: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1', color: '#1E293B' }
                                }}
                            >
                                <EditIcon sx={{ fontSize: '16px' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Entry" placement="top">
                            <IconButton
                                onClick={(e) => {
                                    handleOnClickDelete(params.row._id)
                                }}
                                sx={{ 
                                    color: '#EF4444', padding: '6px', borderRadius: '8px', border: '1px solid #FEE2E2', backgroundColor: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#FEF2F2', borderColor: '#FCA5A5' }
                                }}
                            >
                                <DeleteOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )
            }
        }
    ];

    return (
        <Box className="sc--settings--card" sx={{ width: '100%', boxSizing: 'border-box', p: 2.5 }}>
            
            {/* Modal: Irreversible Wipe Intercept Safe Box Dialog */}
            <Modal
                open={deleteModalopen}
                onClose={deleteModalClose}
                aria-labelledby="delete-modal-title"
                aria-describedby="delete-modal-description"
                closeAfterTransition
            >
                <Box sx={enterpriseAddressDeleteModalStyles}>
                    <Typography id="delete-modal-title" variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', mb: 1.5, textAlign: 'center', fontSize: '16px' }}>
                        Delete Recipient Address
                    </Typography>
                    <Typography id="delete-modal-description" variant="body2" sx={{ color: '#475569', fontWeight: 500, lineHeight: 1.6, mb: 4, textAlign: 'center' }}>
                        Are you sure want to delete this recipient address?<br />This deployment mapping choice profile is permanent.
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, width: '100%' }}>
                        <Button 
                            variant="outlined" 
                            onClick={deleteModalClose}
                            sx={{
                                textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 3.5,
                                borderColor: '#E2E8F0', color: '#475569', '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                            }}
                        >
                            No, Keep
                        </Button>
                        <Button 
                            variant="contained" 
                            onClick={(event) => deleteaddress(deleteid)}
                            sx={{
                                textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 4.5, boxShadow: 'none',
                                backgroundColor: '#EF4444', color: '#FFFFFF', '&:hover': { backgroundColor: '#DC2626', boxShadow: 'none' }
                            }}
                        >
                            Yes, Delete
                        </Button>
                    </Box>
                </Box>
            </Modal>
            
            <Modalpopup
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                formValues={selectedItem}
                setFormValues={setSelectedItem}
            />
            <ModalImportPopup
                modalImportVisible={modalImportVisible}
                setModalImportVisible={setModalImportVisible}
                setSnackOpen={setSnackOpen}
                setAlertImport={setAlertImport}
            />
            
            {addressAlert && (addressrecipient && addressrecipient.loading === false) && (
                <Snackbar
                    open={snackOpen}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    autoHideDuration={6000}
                    onClose={snackhandleClose}
                    sx={{ mt: 2 }}
                >
                    <Alert
                        severity={addressrecipient && addressrecipient.hasErrors === true ? "error" : "success"}
                        onClose={snackhandleClose}
                        variant="filled"
                        sx={{ width: '100%', borderRadius: '12px', fontWeight: 600, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.05)', fontSize: '13px', alignItems: 'center' }}
                    >
                        {addressrecipient && addressrecipient.message}
                    </Alert>
                </Snackbar>
            )}
            
            {alertImport && (importaddressrecipient && importaddressrecipient.loading === false) && (
                <Snackbar
                    open={snackOpen}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    autoHideDuration={6000}
                    onClose={snackhandleClose}
                    sx={{ mt: 2 }}
                >
                    <Alert
                        severity={importaddressrecipient && importaddressrecipient.hasErrors === true ? "error" : "success"}
                        onClose={snackhandleClose}
                        variant="filled"
                        sx={{ width: '100%', borderRadius: '12px', fontWeight: 600, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.05)', fontSize: '13px', alignItems: 'center' }}
                    >
                        {importaddressrecipient && importaddressrecipient.message}
                    </Alert>
                </Snackbar>
            )}

            {/* Core Card Document Presentation Surface Workspace */}
            <Card 
                sx={{ 
                    width: '100%', 
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden'
                }} 
                className="sc--cardhead--details"
            >
                <Box 
                    sx={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2.5, borderBottom: '1px solid #E2E8F0', flexWrap: 'wrap', gap: 2
                    }}
                >
                    <Typography variant="h5" component="h1" sx={{ fontWeight: 800, color: '#0F172A', letterSpacing: '-0.5px', margin: 0, fontSize: '1.25rem' }}>
                        Recipient Address
                    </Typography>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Tooltip title="Toggle Search Bar" placement="top">
                            <IconButton 
                                onClick={onMenuClick}
                                sx={{ 
                                    color: showSearch ? '#1976d2' : '#64748B', borderRadius: '8px', border: '1px solid',
                                    borderColor: showSearch ? 'rgba(25, 118, 210, 0.2)' : '#E2E8F0', p: 1, transition: 'all 0.15s ease-in-out',
                                    backgroundColor: showSearch ? 'rgba(25, 118, 210, 0.04)' : '#FFFFFF',
                                    '&:hover': { backgroundColor: showSearch ? 'rgba(25, 118, 210, 0.08)' : '#F1F5F9' }
                                }}
                            >
                                <SearchIcon sx={{ fontSize: '18px' }} />
                            </IconButton>
                        </Tooltip>
                        
                        <Tooltip title="Add Recipient Address" placement="top">
                            <IconButton 
                                onClick={() => setModalVisible(true)}
                                sx={{ 
                                    color: '#1976d2', borderRadius: '8px', border: '1px solid #E2E8F0', p: 1, transition: 'all 0.15s ease-in-out', backgroundColor: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#115293' }
                                }}
                            >
                                <AddCircleOutlineRoundedIcon sx={{ fontSize: '18px' }} />
                            </IconButton>
                        </Tooltip>
                        
                        <Tooltip title="Import Addresses via CSV" placement="top">
                            <IconButton 
                                onClick={() => setModalImportVisible(true)}
                                sx={{ 
                                    color: '#1976d2', borderRadius: '8px', border: '1px solid #E2E8F0', p: 1, transition: 'all 0.15s ease-in-out', backgroundColor: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#115293' }
                                }}
                            >
                                <UploadIcon sx={{ fontSize: '18px' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Divider sx={{ display: 'none' }} />
                
                <CardContent sx={{ p: 0 }}>
                    {/* Collapsible Search Workspace Engine Block Drawer */}
                    {showSearch && (
                        <Box sx={{ p: 2.5, backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0' }}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={4} md={3}>
                                    <FormControl fullWidth variant="outlined" size="small" sx={enterpriseAddressInputStyles}>
                                        <InputLabel id="search-by-select-label">Search By</InputLabel>
                                        <Select
                                            labelId="search-by-select-label"
                                            id="search-by-select"
                                            name="search_by"
                                            value={addressSearchValues.search_by}
                                            onChange={onSearchAddressFieldsChange}
                                            label="Search By"
                                        >
                                            <MenuItem value="name">Name</MenuItem>
                                            <MenuItem value="company">Company</MenuItem>
                                            <MenuItem value="address">Address</MenuItem>
                                            <MenuItem value="address2">Address 2</MenuItem>
                                            <MenuItem value="city">City</MenuItem>
                                            <MenuItem value="province_code">Province Code</MenuItem>
                                            <MenuItem value="country_code">Country Code</MenuItem>
                                            <MenuItem value="postal_code">Postal Code</MenuItem>
                                            <MenuItem value="email">Email</MenuItem>
                                            <MenuItem value="phone">Phone</MenuItem>
                                            <MenuItem value="customer_id">Customer ID</MenuItem>
                                            <MenuItem value="reference">Reference</MenuItem>
                                            <MenuItem value="reference2">Reference 2</MenuItem>
                                            <MenuItem value="reference3">Reference 3</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={8} md={5}>
                                    <TextField
                                        placeholder={"Enter keyword lookup for " + addressSearchValues.search_by.replace("_", " ")}
                                        label={addressSearchValues.search_by.replace("_", " ").toUpperCase()}
                                        size="small"
                                        variant="outlined"
                                        name="search_value"
                                        value={addressSearchValues.search_value}
                                        inputProps={{ min: 2, maxLength: 25 }}
                                        onChange={onSearchAddressFieldsChange}
                                        onKeyPress={onSearchAddressFieldsEnter}
                                        sx={enterpriseAddressInputStyles}
                                        InputProps={{
                                            endAdornment: addressSearchValues.search_value ? (
                                                <IconButton size="small" onClick={() => onInputClear()} sx={{ color: '#94A3B8' }}>
                                                    <ClearIcon sx={{ fontSize: '16px' }} />
                                                </IconButton>
                                            ) : undefined,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    {/* Interactive Recipient Ledger Table Engine Dashboard */}
                    <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                        <DataGrid
                            sx={{
                                border: 'none',
                                backgroundColor: '#FFFFFF',
                                overflow: 'hidden',
                                '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                                '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                                '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                                '& .MuiDataGrid-cell': { borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                                '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } },
                                '& .MuiTablePagination-root': { borderTop: '1px solid #E2E8F0', bgcolor: '#F8FAFC' }
                            }}
                            getRowId={(row) => row._id}
                            rows={addressrecipient && addressrecipient.data ? addressrecipient.data : []}
                            columns={columns}
                            autoHeight={true}
                            disableRowSelectionOnClick={true}
                            sortingMode="server"
                            slots={{
                                loadingOverlay: LinearProgress,
                                noRowsOverlay: NorowsData
                            }}
                            loading={addressrecipient && addressrecipient.loading}
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            rowsPerPageOptions={[5, 10, 20]}
                            pagination
                        />
                    </Box>
                </CardContent>
            </Card>
        </Box>
    )
}

export default AddressRecipientPage;